<template>
  <div class="newYear-recall-page" v-if="true">
    <div v-wechat-title="'最强蜗牛'"></div>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin' :gameName="gameName" :game_id="'39'" :downloadUrl="downloadUrl" :loginTypes="loginTypes"
      :autoOpenOS="autoOpenOS" v-on:selectCallback="loginSuccess" channelTips="角色UID可在游戏中—设置—UID查看"></Login>
    <!-- 头部 -->
    <Header :config='headerConfig' :isOnline='1' :downloadApp="downloadApp" />
    <!-- 内容 -->

    <div class="active-page">

      <div class="section-container">
        <div class="clould"></div>
        <div :class="'section section1 ' + aspectRatio">
          <!-- <div class="btn-box">
            <a class="btn taptap-btn" @click="goLink('https://l.taptap.cn/ovT12vw0?channel=rep-rep_uvbcbbs5do5')"></a>
            <a class="btn hykb-btn" @click="goLink('https://m.3839.com/a/117233.htm')"></a>
          </div> -->
          <div class="banner"></div>
          <div class="recall-box" id="recall-box">
            <div class="detail-btn" data-snail-report-name="活动规则按钮" @click="showPopup('recallDetailShow')">
            </div>

            <div class="recall-content">
              <div v-if="(activeInfo.invite && activeInfo.invite.status === 3) || (userInfo.game_id === 26)"
                class="seal-box">
                <div class="seal-img"></div>
                <!-- <div class="seal-title"></div> -->
              </div>

              <div class="player-box">
                <div class="player-item player-1" @click="loginShow()">
                  <div v-if="activeInfo.invite">
                    <img class="avatar" :src="activeInfo.invite.pic" alt="">
                    <div :class="'medal medal-' + activeInfo.invite.status"></div>
                    <div class="name">我</div>
                  </div>
                </div>
                <div class="player-item player-2">
                  <div v-if="invitePartnerInfo.id">
                    <img class="avatar" :src="invitePartnerInfo.pic" alt="">
                    <div :class="'medal medal-' + invitePartnerInfo.status"></div>
                    <div class="name">{{ invitePartnerInfo.account_name }}</div>
                  </div>
                  <div v-else>
                    <div class="recall-invite-btn" data-snail-report-name="立即邀请" @click="onRecallShare()">
                      <img src="https://download4.qcplay.com/h5-images/active/snail/recall/2/plus.png" alt="">
                    </div>
                  </div>
                </div>
              </div>
              <div class="download-btn" data-snail-report-name="前往春节专题页按钮" @click="toIndex()"></div>
            </div>
          </div>



          <div class="find_team_btn" @click="openFindTeamShow()" data-snail-report-name="加入社群按钮">
            <img src="../../../../assets/images/active/snail/springFestivalActive/recall/find_team_icon.png" />
          </div>

          <!-- 召回分享 -->
          <div class="hide-recall-share-box" ref="recallImageDom">
            <div class="player-item player-1">
              <div v-if="activeInfo.invite">
                <img class="avatar" :src="activeInfo.invite.pic" alt="">
                <div :class="'medal medal-' + activeInfo.invite.status"></div>
                <div class="name">我</div>
              </div>
            </div>
            <img src="../../../../assets/images/active/snail/springFestivalActive/recall/recall-share-popup.png" />
            <div class="share-img">
              <div class="qrcode-box">
                <div id="recall-qrcode" class="qrcode"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 召回绑定弹窗组 -->
    <div :class="'popup_wrap-box '">
      <!-- 召回绑定——详情弹窗 -->
      <div class="recall-detail-wrap popup_wrap" v-show="recallDetailShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-detail-box popup_wrap-box" v-show="recallDetailShow">
            <div class="detail-content" v-if="recallDetailShow">
              <img src="../../../../assets/images/active/snail/springFestivalActive/recall/recall-rule.png" alt="">
            </div>
            <div class="detail-btn" v-show="recallDetailShow" @click="closePopup('recallDetailShow')"></div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallDetailShow" @click="closePopup('recallDetailShow')"></div>
      </div>

      <!-- 召回绑定——召回失败(不符合条件) -->
      <div class="recall-failed-mismatch-condition-wrap popup_wrap" v-show="recallFailedMismatchConditionShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-mismatch-condition-box popup_wrap-box" v-show="recallFailedMismatchConditionShow">
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="失败_参加其他活动"
                @click="closePopup('recallFailedMismatchConditionShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallFailedMismatchConditionShow"
          @click="closePopup('recallFailedMismatchConditionShow')"></div>
      </div>
      <!-- 召回绑定——召回失败(不符合条件2 都是回归玩家) -->
      <div class="recall-failed-mismatch-condition-2-wrap popup_wrap" v-show="recallFailedMismatchConditionShow2">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-mismatch-condition-2-box popup_wrap-box"
            v-show="recallFailedMismatchConditionShow2">
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="失败_参加其他活动"
                @click="closePopup('recallFailedMismatchConditionShow2')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallFailedMismatchConditionShow2"
          @click="closePopup('recallFailedMismatchConditionShow2')"></div>
      </div>

      <!-- 召回绑定——召回失败(自己召回自己弹窗) -->
      <div class="recall-failed-myself-wrap recall-failed-wrap popup_wrap" v-show="recallFailedMyselfShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-myself-box popup_wrap-box" v-show="recallFailedMyselfShow">
            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="召回自己"
                @click="closePopup('recallFailedMyselfShow')"></div>
            </div>
          </div>
        </transition>
        <div class="close-bg" v-show="recallFailedMyselfShow" @click="closePopup('recallFailedMyselfShow')"></div>
      </div>

      <!-- 召回绑定——召回失败(已经满员弹窗) -->
      <div class="recall-failed-full-strength-wrap recall-failed-wrap popup_wrap" v-show="recallFailedFullStrengthShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-full-strength-box popup_wrap-box" v-show="recallFailedFullStrengthShow">

            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="失败_满员"
                @click="closePopup('recallFailedFullStrengthShow')"></div>
            </div>
          </div>
        </transition>
      </div>

      <!-- 召回绑定——召回失败(已有队伍弹窗) -->
      <div class="recall-failed-has-team-wrap recall-failed-wrap popup_wrap" v-show="recallFailedHasTeamShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-failed-has-team-box popup_wrap-box" v-show="recallFailedHasTeamShow">

            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="失败_已有队伍"
                @click="closePopup('recallFailedHasTeamShow')"></div>
            </div>
          </div>
        </transition>
      </div>
      <!-- 召回绑定——召回邀请二次确定 -->
      <div class="recall-invitation-second-wrap popup_wrap" v-show="recallInvitationSecondShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-invitation-second-box popup_wrap-box" v-show="recallInvitationSecondShow">

            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="绑定确认弹窗-我再想想按钮"
                @click="closePopup('recallInvitationSecondShow')"></div>
              <div class="btn my-team-btn" data-snail-report-name="绑定确认弹窗-确认绑定按钮" @click="acceptInvitation()"></div>
            </div>
          </div>
        </transition>
      </div>
      <!-- 召回绑定——召回邀请 -->
      <div class="recall-invitation-wrap popup_wrap" v-show="recallInvitationShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="recall-invitation-box popup_wrap-box" v-show="recallInvitationShow">

            <div class="btn-box">
              <div class="btn other-active-btn" data-snail-report-name="老友召回弹窗-我再想想按钮"
                @click="closePopup('recallInvitationShow')"></div>
              <div class="btn my-team-btn" data-snail-report-name="老友召回弹窗-立即加入按钮"
                @click="showPopup('recallInvitationSecondShow')"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>


    <!-- 召回绑定——微信分享 -->
    <div class="recall-wechat-share-wrap popup_wrap" v-show="recallWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="recall-wechat-share-box popup_wrap-box" v-show="recallWechatShareShow">
        </div>
      </transition>
      <div class="close-bg" v-show="recallWechatShareShow" @click="closeWechatShare('recallWechatShareShow')"></div>
    </div>
    <!-- 召回绑定——分享弹窗 -->
    <div class="recall-share-wrap popup_wrap" v-show="recallNotWechatShareShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="recall-share-box popup_wrap-box" v-show="recallNotWechatShareShow">
          <img :src="recallShareImg" alt="分享图片" :class="'hide-' + aspectRatio" />
          <div class="share-tips"></div>
          <button class="monitor-btn" @click="onCopy('recall-clipboard-btn')" id="recall-clipboard-btn"
            data-snail-report-name="分享弹窗-复制链接按钮" data-event="复制邀请链接"
            :data-clipboard-text="recallShareCopy.linkText + recallShareLink"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="recallNotWechatShareShow" @click="closePopup('recallNotWechatShareShow')"></div>
    </div>


    <!-- 角色选择 -->
    <div class="snail-role-select-wrap popup_wrap" v-show="snailRoleSelect">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="snail-role-select-box popup_wrap-box" v-show="snailRoleSelect">

          <div class="option-box">
            <div class="input">
              <select v-model="selectedRoleID" @focus="inputFocus()" @focusout="inputFocusOut()">
                <option value="">请选择区组</option>
                <option v-for="(item, index) in roleList" :key="index" :value="item.role_id">
                  <span>{{ "区服:" + item.server_name + " 综合实力:" + (item.extra && item.extra.score) }}</span>
                </option>
              </select>
            </div>
            <div class="input input-name">
              <input type="text" name="" readonly v-model="roleName" placeholder="请选择角色" @focus="inputFocus()"
                @focusout="inputFocusOut()" />
            </div>
          </div>
          <div class="btn-box">
            <div class="cancel-btn" data-snail-report-name="取消绑定角色"
              @click="closeConfirmBindRole('snailRoleSelect')"></div>
            <div class="confirm-btn" data-snail-report-name="确认绑定角色" @click="confirmBindRole()"></div>
          </div>
        </div>
      </transition>
    </div>

    <!-- 寻找组队搭子 -->
    <div class="find-team-wrap popup_wrap" v-show="findTeamShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="find-team-box popup_wrap-box" v-show="findTeamShow">
          <div class="btn-box">
            <div class="btn qq-btn" data-snail-report-name="社群弹窗-前往QQ群按钮" @click="toGroupOfQQ()"></div>
            <div class="btn wechat-btn" data-snail-report-name="社群弹窗-前往微信群按钮" @click="toGroupOfWechat()"></div>
          </div>
        </div>
      </transition>
      <div class="close-bg" v-show="findTeamShow" @click="closePopup('findTeamShow')"></div>
    </div>

    <!-- QQ群 -->
    <div class="qq-group-wrap popup_wrap" v-show="qqGroupShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
        :duration="{ enter: 1000 }">
        <div class="qq-group-box popup_wrap-box" v-show="qqGroupShow">
          <div class="num">{{ qqNumber }}</div>
          <button class="monitor-btn" @click="onCopy('qq-clipboard-btn')" id="qq-clipboard-btn"
            data-snail-report-name="QQ群弹窗-一键复制按钮" data-event="复制QQ群号" :data-clipboard-text="qqNumber"></button>
        </div>
      </transition>
      <div class="close-bg" v-show="qqGroupShow" @click="closePopup('qqGroupShow')"></div>
    </div>

    <!-- 全局遮罩 -->
    <div :class="'prevent-wrap prevent-wrap-' + preventShow"></div>

  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import { GetRoleList, BindRoleAPI } from "@/api/os";
import Login from '@/components/login';
import Header from '../Header/index.vue';
import Footer from '@/components/Footer';
import { APP_ID, PAGE_ID, GAME_AREA } from "@/config/constant";
import { headerConfig } from '../headerConfig';
import {
  onGetInitDataAPI, recallInitAPI, secretFreeLoginApi, recallBindPlayerAPI, onGetTimeAPI,
  teamKickAPI, teamExitAPI, teamRewardAPI
} from '../api';
import { getRandomString, buriedLogger, wechatBrowser } from '@/utils/utils';
import { generateQRCode, generateCanvasImage } from '@/utils/share';
import { LogoutAPI } from "@/api/login";

// import eruda from 'eruda';

const PLAYER_TYPE = {
  1: '活跃玩家',
  2: '回归玩家',
  3: '新玩家',
};
const ACTIVE_APPOINTMENT_STATUS = 1; // 活动预约期间
const ACTIVE_PROCEED_STATUS = 2; // 活动进行期间

export default {
  name: 'RecallTeamActive',
  components: {
    Header,
    Footer,
    Login,
  },
  data() {
    return {
      headerConfig,
      gameName: 'snail',
      downloadUrl: 'http://snail.qingcigame.com/official/',
      rechargeUrl: 'https://pay.qingcigame.com/pay?gameId=39',
      loginTypes: ["sms", "password"],
      autoOpenOS: false,
      preloadingShow: true,
      logger: null,
      timer: null,
      kickOutTimer: null,
      kickOutSeconds: 0,
      showGrayKickOutBtn: false,
      consumptionLevel: [50, 100, 150, 200, 400, 800, 1500, 3000, 5000, 10000],
      recallShareCopy: {
        title: '《最强蜗牛》即刻返程',
        desc: '回来吧，蜗的爱人！拿着这亿点点资源，上线！',
        linkText: '《最强蜗牛》燕子你别走啊，回来啊，你要的狗眼、水晶、抽奖券蜗通通给你哇~'
      },
      teamShareCopy: {
        title: '',
        desc: '',
        linkText: ''
      },

      code: '',
      auth_code: '',
      friend_id: '',
      recallShareLink: '',
      recallShareImg: '',

      // 弹窗
      preventShow: false, // 全局遮罩
      snailRoleSelect: false, // 角色选择
      findTeamShow: false, // 寻找队伍弹窗
      qqGroupShow: false, // QQ群
      recallDetailShow: false, // 召回绑定——详情弹窗
      recallWechatShareShow: false, // 召回绑定——微信分享弹窗
      recallNotWechatShareShow: false, // 召回绑定——非微信分享弹窗
      recallFailedMismatchConditionShow: false, // 召回绑定——不满足条件弹窗
      recallFailedMyselfShow: false, // 召回绑定——自己召回自己弹窗
      recallFailedFullStrengthShow: false, // 召回绑定——已有好友弹窗
      recallFailedHasTeamShow: false, // 召回绑定——已有队伍弹窗
      recallFailedMismatchConditionShow2: false, // 召回绑定——都是回归玩家
      recallInvitationShow: false, // 召回绑定——邀请弹窗
      recallInvitationSecondShow: false, // 召回绑定——邀请弹窗

      teamDetailShow: false, // 组队消费——详情弹窗
      teamWechatShareShow: false, // 组队消费——微信分享弹窗
      teamNotWechatShareShow: false, // 组队消费——非微信分享弹窗
      teamPlayerInfoShow: false, // 组队消费——玩家信息弹窗
      teamKickOutTipShow: false, // 组队消费——玩家被踢出队伍弹窗
      teamExitShow: false, // 组队消费——退出队伍弹窗
      teamBindRoleConfirmShow: false, // 组队消费——绑定角色确认弹窗
      teamPointsRecordShow: false, // 组队消费——积分记录弹窗
      teamNotPointsRecordShow: false, // 组队消费——积分记录弹窗 无积分
      teamJoinFailedFullStrengthShow: false, // 组队消费——入队失败(满员)
      teamJoinFailedHasTeamShow: false, // 组队消费——入队失败(已有队伍)
      teamJoinFailedMyselfShow: false, // 组队消费——入队失败(自己邀请自己)
      teamInvitationJoinShow: false, // 组队消费——邀请入队弹窗
      teamInvitationConfirmShow: false, // 组队消费——邀请入队确认弹窗

      characterShow: false, // 奖励弹窗——卡片形象详情
      cooperationShow: false, // 奖励弹窗——启航携手礼包
      crystalShow: false, // 奖励弹窗——奇点水晶礼包
      luckyShow: false, // 奖励弹窗——组队幸运礼包
      valuablesShow: false, // 奖励弹窗——贵重物品详情
      activityBenefitsShow: false, // 奖励弹窗——运营活动福利礼包

      recallActiveInfo: {},
      teamActiveInfo: {},
      teamList: Array.from({ length: 6 }, () => ({})),
      packageList: Array.from({ length: 10 }, () => ({})),
      memberNum: 0,
      curPlayerInfo: {},
      invitePartnerInfo: {},

      // 是否需要二次同意
      needInvitationConfirm: false,

      roleList: [],
      selectedRoleID: "",
      isActiveAppointment: true, // 默认在预约期

      recallSharePlayerInfo: {},
      teamInvitationNum: 0,
      teamLevel: 0,
      teamScore: 0,
      scoreList: [],
      rewardLevel: 0,
      rewardList: [],
      selectedRoleInfo: {},
      qqNumber: '',
      qqLink: '',
      wechatLink: '',
      pageLink: '',
      timeAndCheckStartInfo: {
        formalStarted: false,
        photonStarted: false
      }, // 活动开始时间
      timeCheckNoStartMsg: {
        enabled: false,
        msg: '',
        black: ['activityBenefitsShow', 'teamNotPointsRecordShow', 'teamPointsRecordShow', 'giftCardsShow']
      },
      aspectRatio: ''
    }
  },
  async created() {
    // 获取服务器时间并判断开服状态（注意 await）
    this.timeAndCheckStartInfo = await this.onGetTimeAndCheckStart();
    if (!this.timeAndCheckStartInfo.formalStarted) {
      this.timeCheckNoStartMsg.enabled = true
      this.timeCheckNoStartMsg.msg = `活动暂未开启，2月13日05:00开启`
    }
    this.pageLink = window.location.href;

    // 获取url上的参数
    const urlParams = new URLSearchParams(window.location.search);
    this.code = urlParams.get('code');
    this.auth_code = urlParams.get('auth_code');
    this.friend_id = urlParams.get('friend_id');
    const queryUA = urlParams.get('ua');
    const module = urlParams.get('module');

    urlParams.delete('code');
    urlParams.delete('auth_code');
    urlParams.delete('friend_id');
    urlParams.delete('module');
    urlParams.delete('ua');
    const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
    window.history.replaceState(null, '', newUrl);

    // 清空store上的用户数据
    this.setInitActiveInfo();
    this.setInitUserInfo();
    // 初始化
    this.onInitDate(true);

    // 埋点
    const bl = buriedLogger('snail', '新春活动_召回');
    this.logger = bl;

    if (queryUA === 'snail') {
      this.rechargeUrl = 'https://pay.qingcigame.com/pay?gameId=39&ua=snail';
    }
    this.setShare({
      uri: this.pageLink,
      link: this.pageLink,
      title: this.recallShareCopy.title,
      imgUrl: "https://download4.qcplay.com/qcgame-api/tgDlZ6pJbG7UTyu6QAzYBDpFgnRoe0G7TDjCapHv.png",
      desc: this.recallShareCopy.desc,
    });



  },
  props: {
  },
  mounted() {
    this.onAdapt()
    document.addEventListener('click', this.handleGlobalClick, true);

    // const el = document.createElement('div');
    // document.body.appendChild(el);

    // eruda.init({ container: el, useShadowDom: true });
  },
  computed: {
    roleName() {
      // 当区组为空时, 角色名为空
      let roleName = this.selectedRoleID
        ? this.roleList.find(item => item.role_id === this.selectedRoleID).role_name
        : "";
      return roleName;
    },
    finallyScore() {
      if (!this.activeInfo.team) {
        return 0;
      }
      const num = this.packageList[9].has_get_time;
      if (num === 20) {
        return 10000;
      }
      return this.teamScore - num * 10000;
    },
    finallyProcess() {
      if (!this.finallyScore) {
        return 0;
      }
      return Math.min((this.finallyScore / 10000) * 100, 100);
    },
    ...mapState(['userInfo', 'activeInfo', 'isShowLogin']),
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.user_id && oldValue.user_id) {
          // TAG: 注销的时候
          this.clearDate();
        } else if (newValue.user_id !== oldValue.user_id) {
          // TAG: 初始登陆/切换角色的时候
          console.log('初始登陆/切换角色')
          this.getRecallInit();
          const { protocol, host } = window.location;
          this.recallShareLink = `${protocol}//${host}/snail/springFestivalActiveRecall/enter${getRandomString()}?code=${this.activeInfo.invite.code}`;
          this.initRecallShareData();
          this.setUserInfo({ ...this.userInfo });
          this.isActiveAppointment = this.activeInfo.team.activity_status === ACTIVE_APPOINTMENT_STATUS;

        }
      }
    }
  },
  methods: {
    onAdapt() {
      const width = window.innerWidth;
      const height = window.innerHeight;
      const aspectRatio = Number((width / height).toFixed(3));
      console.log('aspectRatio', aspectRatio);

      // 按规则添加
      if (aspectRatio >= 0.63) {
        this.aspectRatio = 'adapt-2';
      } else if (aspectRatio >= 0.585) {
        this.aspectRatio = 'adapt-1';
      } else if (aspectRatio >= 0.5) {
        this.aspectRatio = 'adapt-3';
      } else if (aspectRatio >= 0.4) {
        this.aspectRatio = 'adapt-4';

      }
    },
    // 获取服务器时间 + 判断光子服/正式服是否开始
    async onGetTimeAndCheckStart() {
      // 取本地时间并构造接口同款对象
      function buildLocalTimeResponse() {
        const pad = n => String(n).padStart(2, '0');
        const d = new Date();

        const time =
          `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
          `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

        return {
          code: 200,
          message: 'ok',
          data: { time }
        };
      }
      // // 开始时间（按需改）
      // const targetDate = new Date('2026/02/06 04:59:59');       // 光子服开始
      // const formalTargetDate = new Date('2026/02/13 04:59:59'); // 正式服开始
      const targetDate = new Date('2024/01/13 04:59:59');       // 光子服开始
      const formalTargetDate = new Date('2026/01/13 04:59:59'); // 正式服开始

      const response = await onGetTimeAPI({});
      // const response = buildLocalTimeResponse();
      console.log('buildLocalTimeResponse', response)
      if (response.code !== 200) {
        this.onToast(response.message);
        return { photonStarted: false, formalStarted: false, now: null };
      }

      const serverTimeStr = response.data && response.data.time;
      if (!serverTimeStr) {
        return { photonStarted: false, formalStarted: false, now: null };
      }

      // 保存服务器时间（如果你需要）
      this.data = this.data || {};
      this.$set(this.data, 'time', serverTimeStr);
      // 兼容 Safari：把 "YYYY-MM-DD HH:mm:ss" 转成 "YYYY/MM/DD HH:mm:ss"
      const now = new Date(serverTimeStr.replace(/-/g, '/'));

      const photonStarted = now.getTime() >= targetDate.getTime();
      const formalStarted = now.getTime() >= formalTargetDate.getTime();
      return { photonStarted, formalStarted, now, serverTimeStr };
    },
    // 事件委托
    handleGlobalClick(e) {
      let el = e.target;
      while (el && el !== document) {
        if (el.hasAttribute && el.hasAttribute('data-snail-report-name')) {
          const reportName = el.getAttribute('data-snail-report-name');
          this.logger.sum(`新春活动_召回_${reportName}`);
          break;
        }
        el = el.parentNode;
      }
    },
    cacheAccount(account) {
      if (!account) return;

      const key = 'cacheAccount';

      let arr = [];
      try {
        arr = JSON.parse(localStorage.getItem(key) || '[]');
        if (!Array.isArray(arr)) arr = [];
      } catch (e) {
        arr = [];
      }

      if (!arr.includes(account)) {
        arr.push(account);
        localStorage.setItem(key, JSON.stringify(arr));
      }
    },
    // 初始化
    onInitDate(isFirst = false, data = {}) {
      const params = {
        auth_code: this.auth_code,
        ...(data || {}),
      }
      onGetInitDataAPI(params).then(response => {
        this.onInitDataCallback({ ...response, needAccount: false });
        if (response.code !== 200) {
          this.changeLoginPopup(true)
          !isFirst && this.onToast(response.message);
          return;
        }
        this.invitePartnerInfo = this.activeInfo.invite.invite_list[0] || {};
        this.teamScore = Number(this.activeInfo.team.team_score) || 0;
        this.scoreList = this.activeInfo.team.score_list || [];
        this.rewardLevel = Number(this.activeInfo.team.level) || 0;
        this.rewardList = this.activeInfo.team.reward_list || [];
        this.packageList = this.activeInfo.team.package_list || [];
        this.qqNumber = this.activeInfo.qq;
        this.qqLink = this.activeInfo.qq_link;
        this.wechatLink = this.activeInfo.url_scheme;
        // 光子服退出登录
        if (response.data.user_info.game_id == 26) {
          LogoutAPI().then(response => {
            if (Number(response.code) === 200) {
              // 清空数据 控制弹窗
              window.localStorage.setItem("access_token", "");
              this.setInitUserInfo();
              this.setInitActiveInfo();
              this.changeLoginPopup(true);
              console.log('角色信息获取失败')
              this.onToast('请登录《最强蜗牛》正式服游戏角色');
              this.clearDate()
            }
          });
        }
        // this.cacheAccount(this.userInfo.account)
      });
    },
    clearDate() {
      this.selectedRoleID = ''
      this.teamActiveInfo = {};
      this.recallActiveInfo = {};
      this.memberNum = 0;
      this.roleList = [];
      this.invitePartnerInfo = {};
      this.recallSharePlayerInfo = {};
      this.teamScore = 0;
      this.scoreList = [];
      this.rewardLevel = 0;
      this.rewardList = [];
      this.selectedRoleInfo = {};
      this.recallShareImg = '';
      this.teamInvitationNum = 0;
      this.teamLevel = 0;
      this.code = '';
      this.recallShareCopy = {
        title: '《最强蜗牛》即刻返程',
        desc: '回来吧，蜗的爱人！拿着这亿点点资源，上线！',
        linkText: '《最强蜗牛》燕子你别走啊，回来啊，你要的狗眼、水晶、抽奖券蜗通通给你哇~'
      },
        this.auth_code = '';
    },
    async getRecallInit() {
      // 请求头里面有带code或者auth_code的发起api请求
      if (this.code || this.auth_code) {
        if (this.code === this.activeInfo.invite.code) {
          this.showPopup('recallFailedMyselfShow');
          return false;
        }
        const response = await recallInitAPI({ code: this.code, auth_code: this.auth_code });
        if (response.code === 200) {
          const { is_start, is_my, share_nick_name, share_pic, share_status } = response.data.activity;
          if (!is_start) {
            this.onToast('活动将于2月13日5:00开启，敬请期待！');
          } else if (is_my) {
            // 自己召回自己
            this.showPopup('recallFailedMyselfShow');
          } else {
            this.recallSharePlayerInfo = { share_nick_name, share_pic, share_status };
            this.showPopup('recallInvitationShow');
          }
        } else if (response.code === 405) {
          this.showPopup('recallFailedFullStrengthShow');
        } else {
          this.onToast(response.message);
        }
      }
    },
    downloadApp() {
      this.logger.sum('新春活动_召回_官网');
      window.location.href = this.downloadUrl;
    },
    // 去下载
    toDownload() {
      this.downloadApp();
    },
    goLink(url) {
      if (url === '') return
      Indicator.open();
      setTimeout(() => { window.location.href = url; Indicator.close(); }, 200)
    },
    // 跳转到首页
    toIndex(popupName) {
      this.closePopup(popupName);
      this.recallSharePlayerInfo = {};
      const { protocol, host } = window.location;
      window.location.href = `${protocol}//${host}/snail/springFestival/anniversary${getRandomString()}`;
    },
    openFindTeamShow() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.logger.sum('新春活动_召回_寻找搭子按钮');
      this.showPopup('findTeamShow');
    },
    toGroupOfQQ() {
      if (wechatBrowser()) {
        this.closePopup('recallFailedMismatchConditionShow2');
        this.closePopup('findTeamShow');

        this.showPopup('qqGroupShow');
      } else {
        window.location.href = this.qqLink;
      }
    },
    toGroupOfWechat() {
      window.location.href = this.wechatLink;
    },
    initRecallShareData() {
      try {
        // 设置分享文案
        this.recallShareCopy = {
          title: this.recallShareCopy.title,
          desc: this.recallShareCopy.desc,
          linkText: this.recallShareCopy.linkText,
        }
        this.qrcode('recall-qrcode', `${this.recallShareLink}`);
        this.$nextTick(() => {
          this.generateRecallShareImage();
        });
      } catch (err) {
        // 错误信息
        console.log('召回分享初始化失败', err);
      }
    },
    // 生成二维码
    qrcode(id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#eee4d4',
        colorLight: '#c5a790'
      });
    },
    onCopy(id) {
      const clipboard = new Clipboard(`#${id}`);
      clipboard.on('success', (e) => {
        this.onToast('复制成功');
        e.clearSelection();
      });
      clipboard.on('error', (e) => {
        this.onToast('复制失败');
      });
    },
    // 分享图片设置
    generateRecallShareImage() {
      generateCanvasImage(this.$refs.recallImageDom)
        .then((canvas) => {
          this.recallShareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('召回分享图生成成功');
        })
        .catch((err) => {
          console.log('召回分享图生成失败', err.message);
        });
    },

    loginShow() {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
        return;
      }
    },

    onRecallShare() {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      if (this.timeCheckNoStartMsg.enabled) {
        this.onToast(this.timeCheckNoStartMsg.msg);
        return
      }
      if (this.invitePartnerInfo.account_name) return
      this.logger.sum('新春活动_召回_邀请老友按钮')

      if (wechatBrowser() && /Mobile/i.test(navigator.userAgent)) {
        const newUrl = `${window.location.pathname}?code=${this.activeInfo.invite.code}`
        window.history.replaceState(null, '', newUrl);
        this.setShare({
          uri: this.pageLink,
          link: this.recallShareLink,
          title: this.recallShareCopy.title,
          imgUrl: "https://download4.qcplay.com/qcgame-api/tgDlZ6pJbG7UTyu6QAzYBDpFgnRoe0G7TDjCapHv.png",
          desc: this.recallShareCopy.desc,
        });
        this.recallWechatShareShow = true;
        this.logger.sum('新春活动_召回_老友活动-微信分享引导遮罩')
      } else {
        this.recallNotWechatShareShow = true;
      }
    },
    closeWechatShare(popupName) {
      this.closePopup(popupName);
      window.history.replaceState(null, '', window.location.pathname);
    },
    // 接受邀请
    async acceptInvitation() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      this.onPreventShow();
      const response = await recallBindPlayerAPI({ code: this.code, auth_code: this.auth_code });
      setTimeout(() => {
        this.code = null
      }, 1000)
      switch (response.code) {
        case 200:
          this.onToast('绑定成功');
          this.onInitDate(false, { code: this.code });
          break;
        case 405:
          // 对方队伍已满员
          this.showPopup('recallFailedFullStrengthShow');
          break;
        case 406: // 不能自己绑定自己 
          this.showPopup('recallFailedMyselfShow');
          break;
        case 407: // 不符合条件
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 408: // 不符合条件
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 501:
          // 自己已经有队伍
          this.showPopup('recallFailedHasTeamShow');
          break;
        case 502:
          // 两个都是回归玩家
          this.showPopup('recallFailedMismatchConditionShow2');
          break;
        case 503: // 不符合条件 有一个人是新玩家的时候
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        case 504: // 不符合条件 两个活跃玩家
          this.showPopup('recallFailedMismatchConditionShow');
          this.onToast(response.message);
          break;
        default:
          this.onToast(response.message);
      }

      this.onPreventClose();
      this.closePopup('recallInvitationSecondShow');
      this.recallSharePlayerInfo = {};
    },
    // 跳转到充值网站
    toRecharge() {
      window.location.href = this.rechargeUrl;
    },
    // 角色选弹窗
    async onBindRolePopup() {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
        return;
      }
      // 获取角色信息 打开角色选择弹窗
      let roleResponse = {}
      try {
        roleResponse = await GetRoleList({
          account: this.userInfo.account,
          page_id: PAGE_ID[this.gameName],
          app_id: APP_ID[this.gameName]
        });
      }
      catch (err) {
        const that = this
        LogoutAPI().then(response => {
          if (Number(response.code) === 200) {
            this.$emit("reInit");
            // 清空数据 控制弹窗
            window.localStorage.setItem("access_token", "");
            this.setInitUserInfo();
            this.setInitActiveInfo();
            this.changeLoginPopup(true);
            console.log('角色信息获取失败')
            this.clearDate()
          }
        });

      }

      if (Number(roleResponse.code) === 200) {
        // 正式服ID
        const serverIds = GAME_AREA[this.gameName][1].id;
        console.log('serverIds', serverIds);
        let data = roleResponse.data[serverIds] || [];
        this.roleList = data['android'];
        if (!this.roleList) {
          LogoutAPI().then(response => {
            if (Number(response.code) === 200) {
              this.$emit("reInit");
              // 清空数据 控制弹窗
              window.localStorage.setItem("access_token", "");
              this.onToast('请登录《最强蜗牛》正式服游戏角色');
              this.setInitUserInfo();
              this.setInitActiveInfo();
              this.changeLoginPopup(true);
              this.clearDate()
            }
          });
          return
        }
        // this.roleList = this.roleList.filter(role => role.game_id !== 26);
        this.selectedRoleID = "";
        this.selectedRoleInfo = {};
        this.showPopup("snailRoleSelect");
      } else {
        this.clearDate()
      }
    },
    closeConfirmBindRole() {
      this.selectedRoleInfo = {};
      this.closePopup('snailRoleSelect');
      LogoutAPI().then(response => {
        if (Number(response.code) === 200) {
          this.$emit("reInit");
          // 清空数据 控制弹窗
          window.localStorage.setItem("access_token", "");
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLoginPopup(true);
          console.log('角色信息获取失败')
          this.clearDate()
        }
      });
    },
    confirmBindRole() {
      let selectInfo = this.roleList.find(
        item => item.role_id === this.selectedRoleID
      );
      selectInfo.type = "android";
      selectInfo.dist = APP_ID[this.gameName];
      selectInfo.extra = JSON.stringify(selectInfo.extra);
      this.selectedRoleInfo = selectInfo;
      this.onPreventShow();
      BindRoleAPI({
        ...this.selectedRoleInfo,
        is_bind: 1,
      }).then((response) => {
        if (Number(response.code) === 200) {
          this.closePopup("snailRoleSelect");
          this.onInitDate();
        } else {
          this.onToast(response.message);
        }
      }).finally(() => {
        this.onPreventClose();
      });
    },
    loginSuccess(e) {
      if (this.timeCheckNoStartMsg.enabled) {
        this.onToast(this.timeCheckNoStartMsg.msg);
        setTimeout(() => {
          this.setInitUserInfo()
          this.setActiveInfo({});
          this.setUserInfo({});
        }, 100)

        return
      }
      setTimeout(() => {
        this.onBindRolePopup();
      })
    },
    clickReward(id) {
      const popupList = [
        'activityBenefitsShow', 'characterShow', 'activityBenefitsShow', 'valuablesShow', 'activityBenefitsShow',
        'activityBenefitsShow', 'crystalShow', 'activityBenefitsShow', 'cooperationShow', 'luckyShow'
      ];
      const popupName = popupList[id];
      if (popupName) {
        this.showPopup(popupName);
      }
    },
    // 格式化日期
    formatDate(dateStr) {
      const date = new Date(dateStr);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes();
      const seconds = date.getSeconds();
      return `${month}-${day} ${hours}:${minutes >= 10 ? minutes : '0' + minutes}:${seconds >= 10 ? seconds : '0' + seconds}`;
    },
    openLoginByScore() {
      if (this.userInfo.user_id === undefined) {
        this.changeLoginPopup(true);
      }
    },
    openLoginByPlayer() {
      if (this.userInfo.account === undefined) {
        this.changeLoginPopup(true);
      }
      this.onBindRolePopup()
    },
    // TAG: 其他简易封装的方法
    onToast(config, duration) {
      const curConfig = {
        duration: duration || 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig)
    },
    // 打开遮罩
    onPreventShow() {
      Indicator.open();
      this.preventShow = true;
    },
    // 关闭遮罩
    onPreventClose() {
      Indicator.close();
      this.preventShow = false;
    },
    showPopup(name) {
      if (this.timeCheckNoStartMsg.enabled && this.timeCheckNoStartMsg.black.includes(name)) {
        return this.onToast(this.timeCheckNoStartMsg.msg);
      }
      if (name === 'recallInvitationSecondShow') {
        this.recallInvitationShow = false
      }
      this[name] = true;
    },
    closePopup(name) {
      if (name === 'recallInvitationShow' || name === 'recallInvitationSecondShow') this.code = null
      this[name] = false;
    },
    inputFocus() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    },
    inputFocusOut() {
      this.timer = setTimeout(() => {
        window.scrollTo(0, 0);
      }, 10);
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
}
</script>


<style lang="less" scoped>
@import url("./index.less");
</style>


// WEBPACK FOOTER //
// src/pages/snail/springFestivalActive/recall/index.vue